export function roomListAll() {
  return '{roomListAll{id, name, active, capacity, label, value}}';
}

export function roomListOnlyActives() {
  return `{
  roomListByFilter(
    filter: {
      id: 0
      active: true
      filterByStatus: true
      updaterId: 0
      capacity: 0
    }
  ) {
    id
    name
    active
    capacity
    label
    value
  }
}`;
}

export function findRoomById(id) {
  return `{
    roomListByFilter(
      filter: {
        id: ${id}
        active: true
        filterByStatus: false
        updaterId: 0
        capacity: 0
      }
    ) {
      id
      name
      description
      capacity
      active
    }
  }`;
}

export function mutation(values) {
  return `
    mutation {
      roomSave(
        room: {
          id: ${values.id ? values.id : 0}
            , name: "${values.name}"
            , description: "${values.description ? values.description : ' '}"
            , active: ${values.active}
            , capacity: ${values.capacity ? values.capacity : 0}
            , filterByStatus: false
            , updaterId: 0
        }),
        {id}
      }`;
}

export function queryRemove(value) {
  return `mutation {roomRemove(id: ${value.id})}`;
}
